import styled from 'styled-components'
import { withColor } from 'utils/styled-decorators'
import { Card } from 'components/common'

export const BlackGlass = styled.div`
  position:absolute;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  justify-content: center;
  align-items: center;
  position: fixed;
  top:0;
  left:0;
  z-index: 99999;
`

export const ModalCard = styled(Card)`
  position: relative;
  max-width: 800px;
  width:100%;
  padding:15px 8px 30px 8px; 
  align-items:stretch;
`

export const CardTitle = styled.div`
  ${withColor('gray')}
  font-size: ${({ theme }) => theme.fontSizes.title};
  font-weight: 700;
  margin-left: 10px;
  margin-top: 3px;  
`

export const CloseButton = styled.p`
  position: absolute;
  right: 24px;
  top: 4px;
  cursor: pointer;
`

export const ItemContainer = styled.div`
  width: auto;
  margin: 0 0 0 10px;

  h4 {
    font-size: 16px;
    margin: 10px 0;
    display: flex;
    align-items: center;
  }

  input {
    width: auto;
    padding: 5px;
    font-size: 18px;
    border: 0.1px solid rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    color: grey;
    margin-right: 10px;
  }
`